export function getCanvasElementById(id: string): HTMLCanvasElement | undefined {
  const canvas = document.getElementById(id);

  if (!(canvas instanceof HTMLCanvasElement)) {
    return undefined;
  }

  return canvas;
}
